import { Injectable } from '@angular/core';
import { TuningShortTextService } from './tuning-short-text.service';
import { StringsService } from './strings.service';
import { NotesService } from './notes.service';

export class Tuning {
  preferredNote12?: number;
  preferredChord?: string;
  preferredScale?: string;
  name!: string;
  notes!: string;
  intervals?: string;
  likes?: number;
}
/** export class Chapter {
  id: number;
  title: string;
  tunings: Tuning[];
} */
export class Chapter {
  id!: number;
  titleEn!: string;
  titleFr!: string;
  shortEn!: string;
  shortFr!: string;
  tunings!: Tuning[];
  description?: string;
}

@Injectable({
  providedIn: 'root'
})
export class TuningsService {
  public bass4Strings: Tuning[] = [
    { notes: 'E A D G', name: 'Standard' },
    { notes: 'D A D G', name: 'Drop D' }
  ];
  public bass5Strings: Tuning[] = [
    { notes: 'B E A D G', name: 'Standard' },
    { notes: 'D A D G C', name: 'Drop D' }
  ];
  public ukeTunings: Tuning[] = [
    { notes: 'G C E A', name: 'Standard (soprano, tenor & concert)' },
    { notes: 'G# C# F Bb', name: 'Alternate soprano & concert' },
    { notes: 'A D F# B', name: 'Alternate soprano & concert' }
  ];
  public otherTunings: Tuning[] = [
    { notes: 'D G B E', name: 'Baritone Ukulele' },
    { notes: 'C G D A', name: 'Banjo Standard Tenor' },
    { notes: 'G D A E', name: 'Banjo Irish Tenor or Standard Mandolin (double strings)' }
  ];
  public sevenStrings: Tuning[] = [
    { notes: 'B E A D G B E', name: 'Standard' },
    { notes: 'A E A D G B E', name: 'Standard low A (jazz)' },
    { notes: 'E A D G B E A', name: 'Breau tuning' },
    { notes: 'G C F C F Bb D', name: 'Hunter tuning' },
    { notes: 'C E A D G B E', name: 'Brazilian Choro tuning' },
    { notes: 'B D A D G B E', name: 'Drop D' },
    { notes: 'A D A D G B E', name: 'Drop D & A' },
    { notes: 'E G# C E G# C E', name: 'Thirds Tuning' },
    { notes: 'B E A D G C F', name: 'All Fourths Tuning' },
    { notes: 'D G B D G B D', name: 'Russian guitar (open G)' }
  ];
  public eightStrings: Tuning[] = [
    { notes: 'F# B E A D G B E', name: 'Standard' },
    { notes: 'F# B E A D G C F', name: 'Fourths tuning' },
    { notes: 'B E A D G B E A', name: 'With high A' },
    { notes: 'D A D A D G B E', name: 'DA tuning' },
    { notes: 'E A D A D G B E', name: 'Hunter tuning' }
  ]
  public other: Tuning[] = [
    {
      intervals: '',
      notes: 'A D G C E A',
      name: 'Gambale tuning'
    },
    {
      intervals: '',
      notes: 'G G D D D# D#',
      name: 'Brother James tuning'
    },
    {
      intervals: '',
      notes: 'F# F# F# F# G B',
      name: 'Death Valley tuning'
    },
    {
      intervals: '',
      notes: 'e a d g B E',
      name: 'Nashville tuning'
    },
    {
      intervals: '',
      notes: 'E A D G C F',
      name: 'Fourths tuning'
    },
    {
      intervals: '',
      notes: 'E A D G# B E',
      name: ''
    },
    {
      intervals: '',
      notes: 'E A D G B D',
      name: 'Treble drop-D / Double First'
    },
    {
      intervals: '',
      notes: 'E A D F# B E',
      name: 'Lute tuning / Drop-# tuning '
    },
    {
      intervals: '',
      notes: 'Eb Ab C# F# Bb Eb',
      name: 'Half step down'
    },
    {
      intervals: '',
      notes: 'D G C F A D',
      name: 'Dropped Standard / whole-step down'
    },
    {
      intervals: '',
      notes: 'C G D A E G',
      name: 'Robert Fripp\'s Crafty Tuning / New Standard Tuning'
    },
    {
      intervals: '',
      notes: 'C G C F A D',
      name: 'Dropped Standard / dropped whole-step down'
    },
    {
      intervals: '',
      notes: 'C G C D G A',
      name: 'Martin Carthy\'s tuning'
    },
    {
      intervals: '',
      notes: 'B E A D F# B',
      name: 'Baritone tuning (down a fifth)'
    }
  ];

  public inC: Tuning[] = [
    {
      preferredNote12: 0,
      preferredScale: 'major',
      intervals: '1 1 2 5 6 9',
      notes: 'C C D G A D',
      name: 'C6sus2'
    },
    {
      preferredNote12: 0,
      preferredScale: 'major',
      intervals: '1 1 1 5 1 3',
      notes: 'C C C G C E',
      name: 'Open C'
    },
    {
      preferredNote12: 0,
      preferredScale: 'major',
      intervals: '1 1 5 1 1 1',
      notes: 'C C G C C C',
      name: 'Open C'
    },
    {
      preferredNote12: 0,
      preferredScale: 'major',
      intervals: '1 6 2 5 7 3',
      notes: 'C A D G B E',
      name: 'Drop C'
    },
    {
      preferredNote12: 0,
      preferredScale: 'major',
      intervals: '1 6 1 5 1 3',
      notes: 'C A C G C E',
      name: 'C6',
      likes: 1
    },
    {
      preferredNote12: 0,
      preferredScale: 'major',
      intervals: '1 5 3 5 1 3',
      notes: 'C G E G C E',
      name: 'Open C'
    },
    {
      preferredNote12: 0,
      preferredScale: 'major',
      intervals: '1 5 2 1 5 9',
      notes: 'C G D C G D',
      name: 'Cadd9'
    },
    {
      preferredNote12: 0,
      preferredScale: 'major',
      intervals: '1 5 2 5 1 2',
      notes: 'C G D G C D',
      name: 'Orkney tuning',
      likes: 1
    },
    {
      preferredNote12: 0,
      preferredScale: 'major',
      intervals: '1 5 2 5 1 3',
      notes: 'C G D G C E',
      name: 'Cadd2'
    },
    {
      preferredNote12: 0,
      preferredScale: 'major',
      intervals: '1 5 2 5 7 3',
      notes: 'C G D G B E',
      name: 'C G - standard'
    },
    {
      preferredNote12: 0,
      preferredScale: 'major',
      intervals: '1 5 2 5 6 9',
      notes: 'C G D G A D',
      name: 'C6add9'
    },
    {
      preferredNote12: 0,
      preferredScale: 'major',
      intervals: '1 5 2 4 1 3',
      notes: 'C G D F C E',
      name: 'Cadd2'
    },
    {
      preferredNote12: 0,
      preferredScale: 'major',
      intervals: '1 5 1 5 1 4',
      notes: 'C G C G C F',
      name: 'Csus4'
    },
    {
      preferredNote12: 0,
      preferredScale: 'major',
      intervals: '1 5 1 5 1 3',
      notes: 'C G C G C E',
      name: 'Open C'
    },
    {
      preferredNote12: 0,
      preferredScale: 'minor',
      intervals: '1 5 1 5 1 b3',
      notes: 'C G C G C Eb',
      name: 'Open Cm'
    },
    {
      preferredNote12: 0,
      preferredScale: 'major',
      intervals: '1 5 1 5 1 2',
      notes: 'C G C G C D',
      name: 'Csus2'
    },
    {
      preferredNote12: 0,
      preferredScale: 'major',
      intervals: '1 5 1 5 1 1',
      notes: 'C G C G C C',
      name: 'Open C (no 3)'
    },
    {
      preferredNote12: 0,
      preferredScale: 'major',
      intervals: '1 5 1 4 1 4',
      notes: 'C G C F C F',
      name: 'Csus4'
    },
    {
      preferredNote12: 0,
      preferredScale: 'major',
      intervals: '1 5 1 4 1 3',
      notes: 'C G C F C E',
      name: 'Csus4'
    },
    {
      preferredNote12: 0,
      preferredScale: 'major',
      intervals: '1 5 1 4 1 9',
      notes: 'C G C F C D',
      name: 'Csus4add9'
    },
    {
      preferredNote12: 0,
      preferredScale: 'major',
      intervals: '1 5 1 4 6 9',
      notes: 'C G C F A D',
      name: 'Drop-C'
    },
    {
      preferredNote12: 0,
      preferredScale: 'major',
      intervals: '1 5 1 4 5 7',
      notes: 'C G C F G B',
      name: 'Cmaj7sus4'
    },
    {
      preferredNote12: 0,
      preferredScale: 'major',
      intervals: '1 5 5 9 5 9',
      notes: 'C G G D G D',
      name: 'Cadd9'
    },
    {
      preferredNote12: 0,
      preferredScale: 'major',
      intervals: '1 4 1 5 6 3',
      notes: 'C F C G A E',
      name: 'C6add4 / Am7b6'
    },
    {
      preferredNote12: 0,
      preferredScale: 'major',
      intervals: '1 4 1 1 5 1',
      notes: 'C F C C G C',
      name: 'Cadd4'
    }
  ];

  public inAb: Tuning[] = [
    {
      preferredNote12: 8,
      preferredScale: 'none',
      intervals: '5 1 #4 7 #9 #5',
      notes: 'Eb Ab D G B E',
      name: ''
    },
    {
      preferredNote12: 8,
      preferredScale: 'none',
      intervals: '4 1 5 b6 1 5',
      notes: 'C# G# D# E G# D#',
      name: 'G#(b6)'
    }
  ];

  public inA: Tuning[] = [
    {
      preferredNote12: 9,
      preferredScale: 'minor',
      intervals: '5 1 5 b7 9 5',
      notes: 'E A E G B E',
      name: 'A9'
    },
    {
      preferredNote12: 9,
      preferredScale: 'minor',
      intervals: '5 1 4 b7 1 5',
      notes: 'E A D G A E',
      name: 'A Tuning'
    },
    {
      preferredNote12: 9,
      preferredScale: 'minor',
      intervals: '5 1 4 b7 1 4',
      notes: 'E A D G A D',
      name: 'A7sus4'
    },
    {
      preferredNote12: 9,
      preferredScale: 'minor',
      intervals: '5 1 4 b7 1 b3',
      notes: 'E A D G A C',
      name: 'Am7add4'
    },
    {
      preferredNote12: 9,
      preferredScale: 'major',
      intervals: '5 1 4 5 1 5',
      notes: 'E A D E A E',
      name: 'Pipe tuning'
    },
    {
      preferredNote12: 9,
      preferredScale: 'major',
      intervals: '5 1 5 1 3 5',
      notes: 'E A E A C# E',
      name: 'Open A / Spanish Tuning',
      likes: 1
    },
    {
      preferredNote12: 9,
      preferredScale: 'major',
      intervals: '4 1 3 5 1 5',
      notes: 'D A C# E A E',
      name: 'A/d'
    },
    {
      preferredNote12: 9,
      preferredScale: 'minor',
      intervals: '5 1 5 1 b3 5',
      notes: 'E A E A C E',
      name: 'Am'
    },
    {
      preferredNote12: 9,
      preferredScale: 'minor',
      intervals: 'b3 b7 5 5 9 5',
      notes: 'C G E E B E',
      name: 'Am9'
    },
    {
      preferredNote12: 9,
      preferredScale: 'major',
      intervals: '1 1 4 1 1 3',
      notes: 'A A D A A C#',
      name: 'Aadd4'
    },
    {
      preferredNote12: 9,
      preferredScale: 'major',
      intervals: '1 5 1 4 6 1',
      notes: 'A E A D F# A',
      name: 'Double-Drop A'
    }
  ];

  public inG: Tuning[] = [
    {
      preferredNote12: 7,
      intervals: '5 1 5 1 3 5',
      notes: 'D G D G B D',
      name: 'Open G / Spanish Tuning / Taro Patch',
      likes: 1
    },
    {
      preferredNote12: 7,
      name: 'Banjo-style open G',
      notes: 'g G D G B D',
      intervals: '1 1 5 1 3 5'
    },
    {
      preferredNote12: 7,
      name: 'Gadd9',
      notes: 'G G D G G A',
      intervals: '1 1 5 1 1 9'
    },
    {
      preferredNote12: 7,
      name: 'Joni open G',
      notes: 'G G D G B D',
      intervals: '1 1 5 1 3 5'
    },
    {
      preferredNote12: 7,
      intervals: '1 1 4 1 4 5',
      notes: 'G G C G C D',
      name: 'Gsus4'
    },
    {
      preferredNote12: 7,
      intervals: '1 3 5 1 3 5',
      notes: 'G B D G B D',
      name: 'Open G (standard dobro tuning)',
      likes: 1
    },
    {
      preferredNote12: 7,
      intervals: '1 3 5 1 9 5',
      notes: 'G B D G A D',
      name: 'Gadd9 (alternate dobro tuning)'
    },
    {
      preferredNote12: 7,
      preferredChord: 'm',
      intervals: '1 b3 5 1 b3 5',
      notes: 'G Bb D G Bb D',
      name: 'Open Gm'
    },
    {
      preferredNote12: 7,
      preferredChord: 'm',
      intervals: '5 1 5 2 b3 6',
      notes: 'D G D A Bb E',
      name: ''
    },
    {
      preferredNote12: 7,
      preferredChord: 'm',
      intervals: '5 1 5 1 b3 5',
      notes: 'D G D G Bb D',
      name: 'Open Gm'
    },
    {
      preferredNote12: 7,
      preferredChord: 'm7',
      intervals: '5 1 5 1 b3 4',
      notes: 'D G D G Bb C',
      name: 'Gm7'
    },
    {
      preferredNote12: 7,
      intervals: '5 1 5 1 5 1',
      notes: 'D G D G D G',
      name: 'G5'
    },
    {
      preferredNote12: 7,
      intervals: '5 1 5 1 5 7',
      notes: 'D G D G D F#',
      name: 'Gmaj7'
    },
    {
      preferredNote12: 7,
      intervals: '5 1 5 1 3 5',
      notes: 'D G D G B D',
      name: 'Open G'
    },
    {
      preferredNote12: 7,
      intervals: '5 1 5 5 9 5',
      notes: 'D G D D A D',
      name: 'Gadd9'
    },
    {
      preferredNote12: 7,
      intervals: '5 1 5 1 4 5',
      notes: 'D G D G C D',
      name: 'Gsus4'
    },
    {
      preferredNote12: 7,
      intervals: '5 1 5 1 1 5',
      notes: 'D G D G G D',
      name: 'G5'
    },
    {
      preferredNote12: 7,
      intervals: '5 1 5 1 3 6',
      notes: 'D G D G B E',
      name: 'G6 / Drop-G',
      likes: 1
    },
    {
      preferredNote12: 7,
      intervals: '5 1 5 1 9 5',
      notes: 'D G D G A D',
      name: 'Gadd9'
    },
    {
      preferredNote12: 7,
      intervals: '5 1 5 7 3 5',
      notes: 'D G D F# B D',
      name: 'Wahine tuning (Gmaj7)'
    },
    {
      preferredNote12: 7,
      intervals: '5 1 4 1 4 5',
      notes: 'D G C G C D',
      name: 'Gsus4'
    },
    {
      preferredNote12: 7,
      intervals: '4 1 5 1 4 5',
      notes: 'C G D G C D',
      name: 'Gsus4/C \'Orkney tuning\'',
      likes: 1
    },
    {
      preferredNote12: 7,
      intervals: '4 1 5 1 3 5',
      notes: 'C G D G B D',
      name: 'G/c'
    },
    {
      preferredNote12: 7,
      intervals: '4 1 5 1 2 5',
      notes: 'C G D G A D',
      name: 'Gadd9/C'
    },
    {
      preferredNote12: 7,
      intervals: '4 1 1 5 1 5',
      notes: 'C G G D G D',
      name: ' G/c'
    }
  ];

  public inF: Tuning[] = [
    {
      preferredNote12: 5,
      preferredScale: 'minor',
      intervals: '1 5 1 b3 5 1',
      notes: 'F C F Ab C F',
      name: 'F minor',
      likes: 1
    },
    {
      intervals: '1 3 6 9 4 7',
      notes: 'F A D G B E',
      name: ''
    }
  ];

  public inE: Tuning[] = [
    {
      preferredNote12: 4,
      preferredScale: 'major',
      intervals: '1 5 1 4 5 1',
      notes: 'E B E A B E',
      name: 'Esus4'
    },
    {
      preferredNote12: 4,
      preferredScale: 'major',
      intervals: '1 5 1 3 5 1',
      notes: 'E B E G# B E',
      name: 'Open E',
      likes: 1
    },
    {
      preferredNote12: 4,
      preferredScale: 'major',
      intervals: '3 5 1 3 5 1',
      notes: 'G# B E G# B E',
      name: 'Open E',
      likes: 1
    },
    {
      preferredNote12: 4,
      preferredScale: 'minor',
      intervals: '1 5 1 b3 5 1',
      notes: 'E B E G B E',
      name: 'Open Em',
      likes: 1
    },
    {
      preferredNote12: 4,
      preferredScale: 'major',
      intervals: '1 5 1 1 5 1',
      notes: 'E B E E B E',
      name: 'Open E'
    },
    {
      preferredNote12: 4,
      preferredChord: '7',
      intervals: '1 5 b7 3 5 1',
      notes: 'E B D G# B E',
      name: 'E7'
    },
    {
      preferredNote12: 4,
      preferredChord: '7',
      intervals: '1 5 b7 3 5 b7',
      notes: 'E B D G# B D',
      name: 'E7'
    },
    {
      preferredNote12: 4,
      preferredScale: 'minor',
      intervals: '1 5 b7 b3 4 b7',
      notes: 'E B D G A D',
      name: 'Guinnevere tuning (Em7sus4)'
    },
    {
      preferredNote12: 4,
      preferredChord: 'm7',
      intervals: '1 5 5 b3 5 b7',
      notes: 'E B B G B D',
      name: 'Em7'
    },
    {
      preferredNote12: 4,
      intervals: '1 4 b7 9 5 1',
      notes: 'E A D F# B E',
      name: 'E9sus4'
    },
    {
      preferredNote12: 4,
      preferredScale: 'minor',
      intervals: '1 4 6 b3 5 1',
      notes: 'E A C# G B E',
      name: 'Doo-Wop E tuning'
    },
    {
      preferredNote12: 4,
      intervals: '1 3 1 9 5 5',
      notes: 'E G# E F# B B',
      name: 'Eadd9'
    },
    {
      preferredNote12: 4,
      preferredScale: 'major',
      intervals: '1 3 5 3 5 1',
      notes: 'E G# B G# B E',
      name: 'Open E'
    },
    {
      preferredNote12: 4,
      preferredScale: 'major',
      intervals: '1 1 1 1 5 1',
      notes: 'E E E E B E',
      name: 'Bruce Palmer modal tuning'
    }
  ];

  public inEb: Tuning[] = [
    {
      preferredNote12: 3,
      preferredScale: 'minor',
      intervals: '5 1 5 5 1 b3',
      notes: 'Bb Eb Bb Bb Eb Gb',
      name: 'Open Ebm'
    }
  ];

  public inD: Tuning[] = [
    {
      preferredNote12: 2,
      preferredScale: 'major',
      intervals: '1 5 1 4 5 1',
      notes: 'D A D G A D',
      name: 'DADGAD (Dsus4, no 3)',
      likes: 1
    },
    {
      preferredNote12: 2,
      preferredScale: 'minor',
      intervals: 'b3 5 1 1 4 1',
      notes: 'F A D D G D',
      name: 'Dmsus4'
    },
    {
      preferredNote12: 2,
      preferredScale: 'minor',
      intervals: '1 5 b3 4 5 1',
      notes: 'D A F G A D',
      name: 'Dmadd4'
    },
    {
      preferredNote12: 2,
      preferredScale: 'minor',
      intervals: '1 5 2 b3 5 9',
      notes: 'D A E F A E',
      name: 'Dmadd9'
    },
    {
      preferredNote12: 2,
      preferredScale: 'major',
      intervals: '1 5 1 1 5 1',
      notes: 'D A D D A D',
      name: 'D5'
    },
    {
      preferredNote12: 2,
      preferredScale: 'major',
      intervals: '1 5 1 4 1 4',
      notes: 'D A D G D G',
      name: 'Dsus4'
    },
    {
      preferredNote12: 2,
      preferredScale: 'major',
      intervals: '1 5 1 4 1 3',
      notes: 'D A D G D F#',
      name: 'Dadd4'
    },
    {
      preferredNote12: 2,
      preferredScale: 'minor',
      intervals: '1 5 1 4 b7 9',
      notes: 'D A D G C E',
      name: 'D9sus4'
    },
    {
      preferredNote12: 2,
      preferredScale: 'none',
      intervals: '1 5 1 4 b7 b9',
      notes: 'D A D G C Eb',
      name: 'Db9sus4'
    },
    {
      preferredNote12: 2,
      preferredScale: 'major',
      intervals: '1 5 1 4 6 9',
      notes: 'D A D G B E',
      name: 'Drop-D',
      likes: 1
    },
    {
      preferredNote12: 2,
      preferredScale: 'major',
      intervals: '1 5 1 4 6 1',
      notes: 'D A D G B D',
      name: 'Double Drop-D / D modal',
      likes: 1
    },
    {
      preferredNote12: 2,
      preferredScale: 'none',
      intervals: '1 5 1 4 6 b7',
      notes: 'D A D G B C',
      name: 'D7-6sus4'
    },
    {
      preferredNote12: 2,
      preferredScale: 'major',
      intervals: '1 5 1 4 5 3',
      notes: 'D A D G A F#',
      name: 'Dsus4'
    },
    {
      preferredNote12: 2,
      preferredScale: 'major',
      intervals: '1 5 1 3 6 9',
      notes: 'D A D F# B E',
      name: 'D6add9'
    },
    {
      preferredNote12: 2,
      preferredScale: 'major',
      intervals: '1 5 1 3 6 1',
      notes: 'D A D F# B D',
      name: 'D6'
    },
    {
      preferredNote12: 2,
      preferredScale: 'major',
      intervals: '1 5 1 3 5 1',
      notes: 'D A D F# A D',
      name: 'Open D / \'Sebastopol\'',
      likes: 1
    },
    {
      preferredNote12: 2,
      preferredScale: 'minor',
      intervals: '1 5 1 b3 5 1',
      notes: 'D A D F A D',
      name: 'Open Dm'
    },
    {
      preferredNote12: 2,
      preferredScale: 'minor',
      intervals: '1 5 1 b3 5 b7',
      notes: 'D A D F A C',
      name: 'Dm7'
    },
    {
      preferredNote12: 2,
      preferredScale: 'major',
      intervals: '1 5 1 9 5 1',
      notes: 'D A D E A D',
      name: 'Dadd9'
    },
    {
      preferredNote12: 2,
      preferredScale: 'major',
      intervals: '1 5 1 1 5 1',
      notes: 'D A D D A D',
      name: 'D5'
    },
    {
      preferredNote12: 2,
      preferredScale: 'minor',
      intervals: '1 5 b7 4 b7 b3',
      notes: 'D A C G C F',
      name: 'Dm7sus4'
    },
    {
      preferredNote12: 2,
      preferredScale: 'minor',
      intervals: '1 5 b7 4 5 1',
      notes: 'D A C G A D',
      name: 'D7sus4'
    },
    {
      preferredNote12: 2,
      preferredScale: 'major',
      intervals: '1 5 4 4 5 x',
      notes: 'D A G G A x',
      name: 'Dsus4'
    },
    {
      preferredNote12: 2,
      preferredScale: 'major',
      intervals: '1 4 1 4 6 9',
      notes: 'D G D G B E',
      name: 'Drop-D-G'
    },
    {
      preferredNote12: 2,
      preferredScale: 'minor',
      intervals: '1 b3 b7 4 5 1',
      notes: 'D F C G A D',
      name: 'Dm7sus4'
    },
    {
      preferredNote12: 2,
      preferredScale: 'major',
      intervals: '1 1 1 5 1 3',
      notes: 'D D D A D F#',
      name: 'Open D'
    },
    {
      preferredNote12: 2,
      preferredScale: 'major',
      intervals: '5 5 1 3 5 5',
      notes: 'A A D F# A A',
      name: 'Open D'
    }
  ];

  public inB: Tuning[] = [
    {
      preferredNote12: 11,
      preferredScale: 'minor',
      intervals: 'b3 1 1 5 1 4',
      notes: 'D B B F# B E',
      name: 'Bmsus4'
    },
    {
      preferredNote12: 11,
      preferredScale: 'minor',
      intervals: '1 5 b3 b6 1 4 ',
      notes: 'B F# D G B E',
      name: 'B F# - standard  '
    },
    {
      preferredNote12: 11,
      preferredScale: 'major',
      intervals: '1 5 9 5 5 5',
      notes: 'B F# C# F# F# F#',
      name: 'Badd9 (no 3)'
    },
    {
      preferredNote12: 11,
      preferredScale: 'major',
      intervals: '1 5 9 5 5 1',
      notes: 'B F# C# F# F# B',
      name: 'Badd9 (no 3)'
    },
    {
      preferredNote12: 11,
      preferredScale: 'minor',
      intervals: '1 5 9 4 b7 b7 ',
      notes: 'B F# C# E A A',
      name: 'Bm9sus4'
    },
    {
      preferredNote12: 11,
      preferredScale: 'none',
      intervals: '1 5 9 3 b7 3',
      notes: 'B F# C# D A D',
      name: 'Bm9'
    },
    {
      preferredNote12: 11,
      preferredScale: 'major',
      intervals: '1 5 1 5 1 3',
      notes: 'B F# B F# B D#',
      name: 'Open B'
    },
    {
      preferredNote12: 11,
      preferredScale: 'major',
      intervals: '1 5 1 4 1 3',
      notes: 'B F# B E B D#',
      name: 'Bsus4'
    }
  ];

  public inBb: Tuning[] = [
    {
      preferredNote12: 10,
      preferredScale: 'major',
      intervals: '5 1 2 5 7 3',
      notes: 'F Bb C F A D',
      name: 'Bbmaj7add2'
    },
    {
      preferredNote12: 10,
      preferredScale: 'major',
      intervals: '1 5 2 2 4 1',
      notes: 'Bb F C Eb F Bb',
      name: 'Bbadd2sus4'
    },
    {
      preferredNote12: 10,
      preferredScale: 'major',
      intervals: '1 5 1 2 5 1',
      notes: 'Bb F Bb C F Bb',
      name: 'Bbadd2'
    }
  ];

  public standard: Tuning[] = [
    {
      preferredNote12: 0,
      preferredScale: 'major',
      intervals: '3 6 2 5 7 3',
      notes: 'E A D G B E',
      name: 'Standard Guitar Tuning',
      likes: 1
    }
  ];

  public chapters: {
    id: number;
    titleEn: string;
    titleFr: string;
    shortEn: string;
    shortFr: string;
    tunings: Tuning[];
    description?: string;
  }[] = [
    { id: 1, titleEn: 'Tunings in G or Gm',
      titleFr: 'En Sol ou Solm',
      shortEn: 'G', shortFr: 'Sol', tunings: this.inG },
    { id: 2, titleEn: 'Tunings in F and Fm',
      titleFr: 'En Fa ou Fam',
      shortEn: 'F', shortFr: 'Fa', tunings: this.inF },
    { id: 3, titleEn: 'Tunings in E and Em',
      titleFr: 'En Mi ou Mim',
      shortEn: 'E', shortFr: 'Mi', tunings: this.inE },
    { id: 4, titleEn: 'Tunings in Ebm',
      titleFr: 'En Mib mineur',
      shortEn: 'Eb', shortFr: 'Mib', tunings: this.inEb },
    { id: 5, titleEn: 'Tunings in D and Dm',
      titleFr: 'En Ré ou Rém',
      shortEn: 'D', shortFr: 'Ré', tunings: this.inD },
    { id: 6, titleEn: 'Tunings in C and Cm',
      titleFr: 'En Do ou Dom',
      shortEn: 'C', shortFr: 'Do', tunings: this.inC },
    { id: 7, titleEn: 'Tunings in B and Bm',
      titleFr: 'En Si ou Sim',
      shortEn: 'B', shortFr: 'Si', tunings: this.inB },
    { id: 8, titleEn: 'Tunings in Bbm',
      titleFr: 'En Sib mineur',
      shortEn: 'Bb', shortFr: 'Sib', tunings: this.inBb },
    { id: 9, titleEn: 'Tunings in A and Am',
      titleFr: 'En La ou Lam',
      shortEn: 'A', shortFr: 'La', tunings: this.inA },
    { id: 10, titleEn: 'Tunings in Ab or G#',
      titleFr: 'En Sol#',
      shortEn: 'Ab', shortFr: 'Lab', tunings: this.inAb },
    {
      id: 11,
      titleEn: 'Other tunings',
      titleFr: 'Autres accordages',
      shortEn: '?',
      shortFr: '?',
      tunings: this.other,
      description: `Other tunings, not meant for any particular key, or for which the intended
        key is not obvious...`
    },
    { id: 12, titleEn: 'Standard tuning',
    titleFr: 'Accordage standard',
    shortEn: 'Standard',
    shortFr: 'Standard',
    tunings: this.standard }
  ];
  constructor(
    public shortEn: TuningShortTextService,
    public stringsService: StringsService,
    public notesService: NotesService
  ) {

  }
  manageArrays() {
    const list: string[] = [];
    this.chapters.forEach((chapter) => {
      chapter.tunings.forEach((tuning: Tuning) => {
        list.push(tuning.notes);
        if (!this.shortEn.all[tuning.notes]) {
          console.log(tuning.notes);
        }
      });
    });
    for (const sh in this.shortEn.all) {
      if (this.shortEn.all.hasOwnProperty(sh)) {
        const obj = this.shortEn.all[sh];
        if ((obj.strings === 6) && (obj.instru === 'guitar') && (list.indexOf(sh) === -1)) {
          console.log(sh + ' ' + obj.titleen);
        }
      }
    }
  }
  getTuningNamesToValues(
    notes: string,
    instrument: string,
    nbStrings: number
  ): { values: number[], detunes: number[] } {
    const values: number[] = [];
    const detunes: number[] = [];
    const defaultValues = this.stringsService.getDefaultOpenNotes(
      instrument,
      nbStrings
    );
    const notesTab = notes.split(' ');
    if (notesTab.length !== nbStrings) {
      console.log('Error: Invalid nbStrings ' + notesTab.length + ' vs ' + nbStrings );
      return { values: [], detunes: [] };
    }
    const allNotes = [
      'C', 'C#', 'D', 'Eb', 'E', 'F',
      'F#', 'G', 'G#', 'A', 'Bb', 'B',
      'C', 'Db', 'D', 'D#', 'E', 'F',
      'Gb', 'G', 'Ab', 'A', 'A#', 'B'
    ];
    const defaultNotes: string[] = [];
    defaultValues.forEach((note) => {
      defaultNotes.push(this.notesService.disp(note % 12));
      values.push(note);
      detunes.push(0);
    });
    for (let i = 0; i < nbStrings; i++) {
      let value = 0;
      if (notesTab[i] === 'x') {
        value = 0;
      } else {
        let toAdd = 0;
        if (notesTab[i] === 'g') {
          toAdd = 12;
          notesTab[i] = 'G';
        }
        const actual = allNotes.indexOf(defaultNotes[i]);
        const newTune = allNotes.indexOf(notesTab[i]);
        if (newTune === -1) {
          console.log('Error: Unknown note ' + notesTab[i]);
        } else {
          const diff = (actual - newTune + 24) % 12;
          detunes[i] = toAdd + ((diff > 5) ? (12 - diff) : (-diff));
          values[i] += detunes[i];
        }
      }
    }
    return { values, detunes };
  }
  // chapterIndex needed for 6 strings guitar tunings
  getTunings(instru: string, nbStrings: number, chapterIndex?: number) {
    if (instru === 'guitar') {
      if ((nbStrings === 6) && (typeof chapterIndex !== 'undefined')) {
        return this.chapters[chapterIndex].tunings;
      } else if (nbStrings === 7) {
        return this.sevenStrings;
      } else if (nbStrings === 8) {
        return this.eightStrings;
      }
    } else if ((instru === 'manouche') && (typeof chapterIndex !== 'undefined')) {
      return this.chapters[chapterIndex].tunings; 
    } else if (instru === 'bass') {
      return (nbStrings === 5) ? this.bass5Strings : this.bass4Strings;
    } else if (instru === 'ukulele') {
      return [ ...this.ukeTunings, ...this.otherTunings ];
    } else if (['baritone', 'others'].indexOf(instru) !== -1) {
      return [ ...this.otherTunings, ...this.ukeTunings ];
    }
    console.log('Error: tuningsService.getTunings() bad parameters _' + instru + '_' + nbStrings + '_' + chapterIndex + '_');
    return [];
  }
}
